import styled from 'styled-components';
/**
 * An HTML `<button>` element used for closing content such as dialogs.
 */

var CloseButton = styled.button.withConfig({
  displayName: "CloseButton",
  componentId: "sc-sqbalp-0"
})([""]);
/** @component */

export default CloseButton;